import moment from 'moment'
import React from 'react'
import { Card, Table, CardHeader, CardBody } from 'reactstrap'
import useCallApi from '../../../hooks/useCallApi'
import Dollars from '../../UI/Dollars/Dollars'
import Loading from '../../UI/Loading/Loading'
import { Link } from 'react-router-dom'
import DownloadCSV from '../../DownloadCSV/DownloadCSV'

const TransactionDetailsContent = ({ showSystemMessage, transactionHistory, transactionDate }) => {

    return (
        <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
                <div>Conversions</div>
                <div>{transactionHistory && <DownloadCSV filename={`Transaction Details - ${transactionDate}`} headerLabels={['Conversion ID', 'Date', 'Campaign ID', 'Campaign Name', 'Rate', 'Subid1', 'Subid2']} data={transactionHistory} dataLabels={['conversion_id', 'date', 'campaign_id', 'name', 'publisher_rate', 'subid1', 'subid2']} />}</div>
            </CardHeader>
            <CardBody className="p-0">
                <Table striped hover className="m-0 border-0">
                    <thead>
                        <tr className="font-weight-bold">
                            <td>Conversion ID</td>
                            <td>Date</td>
                            <td>#ID</td>
                            <td>Campaign Name</td>
                            <td>Rate</td>
                            <td>Subid1</td>
                            <td>Subid2</td>
                        </tr>
                    </thead>
                    <tbody>
                        {transactionHistory ? (
                            <>
                                {(transactionHistory ? transactionHistory.length : 0) === 0 ? (
                                    <tr>
                                        <td colSpan={8}>No data.</td>
                                    </tr>
                                ) : (
                                    <>
                                        {(transactionHistory ? transactionHistory : []).map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.conversion_id}</td>
                                                    <td>{moment(item.date).format('YYYY-MM-DD HH:mm:ss')}</td>
                                                    <td>{item.campaign_id}</td>
                                                    <td>
                                                        <Link target="_blank" to={`/campaign/${item.campaign_id}`}>{item.name}</Link>
                                                    </td>
                                                    <td>
                                                        <Dollars value={item.publisher_rate} />
                                                    </td>
                                                    <td>{item.subid1}</td>
                                                    <td>{item.subid2}</td>
                                                </tr>
                                            )
                                        })}
                                        <tr>
                                            <td colSpan={4} align="right">
                                                <strong>Total:</strong>
                                            </td>
                                            <td>
                                                <strong>
                                                    <Dollars
                                                        value={(transactionHistory ? transactionHistory : []).reduce(
                                                            (a, b) => a + (b['publisher_rate'] || 0),
                                                            0
                                                        )}
                                                    />
                                                </strong>
                                            </td>
                                            <td colSpan={2}></td>
                                        </tr>
                                    </>
                                )}
                            </>
                        ) : (
                            <tr>
                                <td colSpan={8} align="center">
                                    <Loading />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </CardBody>
        </Card>
    )
}

export default TransactionDetailsContent
